<div class="mb-2">
  <span class="secondary-details mb-2">{{ 'configuration.receiverTaxSetting.receiverTaxSetting' | translate }}</span>
</div>

<div [formGroup]="receiverTaxSetting">
  <div formArrayName="data">
    <ng-container>
      <table aria-describedby="Receiver-table" mat-table [dataSource]="ReceiverDataSource">
        <ng-container matColumnDef="number">
          <th id="number" mat-header-cell *matHeaderCellDef>{{ 'configuration.receiverTaxSetting.number' | translate }}</th>
          <td mat-cell *matCellDef="let row; let i = index">
            {{ i + 1 }}
          </td>
        </ng-container>

        <ng-container matColumnDef="receiverRegistrationType">
          <th
            class="required-field"
            id="receiverRegistrationType"
            mat-header-cell
            *matHeaderCellDef>
            {{ 'configuration.receiverTaxSetting.receiverRegistrationType' | translate }}
          </th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <select
              [ngStyle]="{
                'border-color': getReceiverFormControlId(i, 'receiverRegistrationType').errors
                  ? 'red'
                  : 'grey'
              }"
              class="form-control"
              formControlName="receiverRegistrationType">
              <option value="">{{ 'configuration.receiverTaxSetting.selectRegistrationType' | translate }}</option>
              <option
                *ngFor="let eachType of receiverRegistraionTypes | dataPropertyGetter"
                [value]="eachType.key">
                {{ eachType.key }}, {{ eachType.value }}
              </option>
            </select>
          </td>
        </ng-container>

        <ng-container matColumnDef="receiverRegistrationNumber">
          <th
            class="required-field"
            id="receiverRegistrationNumber"
            mat-header-cell
            *matHeaderCellDef>
            {{ 'configuration.receiverTaxSetting.receiverRegistrationNumber' | translate }}
          </th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <input
              [ngStyle]="{
                'border-color': getReceiverFormControlId(i, 'receiverRegistrationNumber').errors
                  ? 'red'
                  : 'grey'
              }"
              class="form-control"
              type="text"
              formControlName="receiverRegistrationNumber" />
          </td>
        </ng-container>

        <ng-container matColumnDef="receiverIssuingCountryCode">
          <th id="ReceiverLength" mat-header-cell *matHeaderCellDef>
            {{ 'configuration.receiverTaxSetting.receiverIssuingCountryCode' | translate }}*
          </th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <select
              [ngStyle]="{
                'border-color': getReceiverFormControlId(i, 'receiverIssuingCountryCode').errors
                  ? 'red'
                  : 'grey'
              }"
              class="form-control"
              formControlName="receiverIssuingCountryCode">
              <option value="">{{ 'configuration.receiverTaxSetting.selectCountry' | translate }}</option>
              <option *ngFor="let eachListVal of list" [value]="eachListVal.code">
                {{ eachListVal.name }}
              </option>
            </select>
          </td>
        </ng-container>

        <ng-container matColumnDef="Action">
          <th id="action" mat-header-cell *matHeaderCellDef>{{ 'global.action' | translate }}</th>
          <td mat-cell *matCellDef="let row; let i = index">
            <button
              (click)="DeleteReceiverItem(pieces, i)"
              class="ml-2 secondary-btn"
              type="button">
              {{ 'global.delete' | translate }}
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let row; columns: columns"></tr>

        <tr class="mat-row justify-content-center" *matNoDataRow>
          {{ 'global.noDataAvailable' | translate }}
        </tr>
      </table>
    </ng-container>
  </div>
  <div class="col-12 text-end">
    <button (click)="AddNewReceiverItem()" class="secondary-btn" type="button">{{ 'global.addRow' | translate }}</button>
    <button
      [disabled]="!(this.receiverTaxSetting.valid && isValueChanged)"
      (click)="saveReceiverConfig()"
      class="ml-1 primary-btn"
      type="button">
      {{ 'global.save' | translate }}
    </button>
  </div>
</div>
